<!-- The reused header of questions. -->
<template>
	<header>
		<h2
			autofocus
			v-html="questionText"
			:id="`header-${questionData.number}`"
			:data-no-description="questionData.descriptionAbove === `` ? `` : false"
		></h2>
		<p 
			data-description-above 
			:data-has-required-answers="hasRequiredAnswersAndNotHiddenText ? `` : false" 
			v-if="questionData.descriptionAbove" 
			v-html="DOMPurify.sanitize(questionData.descriptionAbove)"
		>
		</p>
		<p v-if="hasRequiredAnswersAndNotHiddenText" data-required-info>
			{{ this.$store.getters.textResource(`rs_mandatory_fields`)}}
		</p>
		<template v-if="questionData.media">
			<template v-for="(media, index) in questionData.media">
				<template v-if="isGraphicImage">
					<img
						v-if="media.mediaType === 'Image'"
						:src="`${state.surveyInfo.domain}/v1/${media.url}`"
						:id="`question-${questionData.number}_media-image`"
						:key="`question-image-${index}`"
						:alt="media.alt"
						data-question-image
						:data-question-image-alignment="media.alignment"
					/>
					<media
						v-else
						:url="media.url"
						:video-id="questionData.media[`${index}`].videoIdentifier"
						:alt="media.alt"
						:type="media.mediaType"
						:extension="media.fileExtension"
						:mimeType="media.mimeType"
						:showImage="showImage"
						:key="`media-${questionData.number}-${index}-${media.url}-${media.mimeType}`"
						:id="`question-${questionData.number}_media-video`"
					/>
				</template>
			</template>
		</template>
	</header>
</template>

<script>
import media from "@/components/Media";

export default {
	name: `question-header`,
    inject: ['DOMPurify'],
	components: {
		media,
	},
	props: {
		// The data of the question that this answer is a part of
		questionData: {
			type: Object,
		},
		showImage: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		state: function () {
			return this.$store.state;
		},
		settings: function () {
			return this.state.settings;
		},
		questionText() {
			if(this.hasRequiredAnswersAndNotHiddenText) {
				return this.DOMPurify.sanitize(this.questionData.text + ` <span data-asterisk>*</span>`);
			}
			return this.DOMPurify.sanitize(this.questionData.text);
		},
		hasRequiredAnswersAndNotHiddenText() {
			return this.hasRequiredAnswers && !this.state.layout.HideRequiredFieldsText;
		},
		hasRequiredAnswers: function () {
			let hasRequiredAnswer;
			let findRequiredAnswers = false;
			let questionType = this.questionData.subQuestions ? this.questionData.subQuestions[0].answers : this.questionData.answers;

			findRequiredAnswers = questionType.find((answer) => answer.validation.required && answer.validation !== undefined);

			if (findRequiredAnswers !== undefined) {
				hasRequiredAnswer = findRequiredAnswers.validation.required;
			}

			return hasRequiredAnswer;
		},
		isGraphicImage(){
			const questionType = this.questionData.type;
			return questionType !== 'TagIt' && questionType !== 'Swipe' && questionType !== 'ImageSingle' && questionType !== 'ImageMulti';
		}
	}
};
</script>

<style scoped>
img[data-is-clickable] {
	cursor: pointer;
    max-width: 100%;
}

[data-question-image] {
	max-width: 720px;
	width: fit-content;
    border-radius: 8px;
	margin: 0 auto;
}

dialog img {
    width: auto;
    max-width: fit-content;
}

[question]:first-of-type header {
		padding-top: 15px;
	
}
[question] header{
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

header {
	background: #fff;
	padding: 5px 40px 5px 35px;
    border-top-left-radius: 32px;
	border-top-right-radius: 32px;

	h2 {
		margin-bottom: 0;
		width: 100%;
		font-size: calc(var(--QuestionStyling-font-size) * 1px);
		font-family: var(--QuestionStyling-font-family-public-name);
		color: var(--QuestionStyling-color);
	}

	p {
		font-size: calc(var(--DescriptionStyling-font-size) * 1px);
		font-family: var(--DescriptionStyling-font-family-public-name);
		color: var(--DescriptionStyling-color);
		margin-top: 15px;
        margin-bottom: 0px;
		width: 100%;
		&:empty {
			display: none;
		}
	}

	[data-description-above] {
		margin-bottom: 15px;
		&[data-has-required-answers] {
			margin-bottom: 0px;
		}
	}

	[data-required-info] {
		font-size: calc(var(--AnswerStyling-font-size) * 1px);
		font-style: italic;
		font-weight: 400;
	}

	&:has([data-question-image]) [data-required-info] {
		margin-bottom: 15px;
	}

	&:empty {
        height: 0;
		padding: 0;
    }

	[data-question-image-alignment="Left"] {
		margin: 0 0 auto 0;
	}

	[data-question-image-alignment="Right"] {
		margin: 0 0 0 auto;
	}
}

header h2[data-no-description] {
	margin-bottom: 17px;
}

@media only screen and (max-width: 550px) {
    [question] header {
        padding: 5px 15px 5px 15px;
    }

	[question]:not(:first-of-type) header h2 {
		margin: 0;
	}
}

</style>
